export const SET_TOGGLE = 'SET_TOGGLE';
export const MENU_NSPACE = 'menu';
export const DOC_URL =
  'https://pixel-networks.atlassian.net/wiki/spaces/PCV3/pages/11075597/PixelAdmin/';

export default () => ({
  namespaced: true,
  state: {
    opened: false,
    menuItems: [
      {
        id: 'account',
        title: 'Account',
        icon: 'mdi-account-circle',
        hideOnDesktop: true,
        ignore: true,
        type: 'default',
        component: 'menuUserPopup'
      },
      {
        id: 'toggle-app',
        title: 'Applications',
        icon: 'mdi-apps',
        hideOnDesktop: true,
        ignore: true,
        type: 'default',
        component: () => import('@/layouts/LayoutDefault/app-bar/AppSelect')
      },
      {
        id: 'divider',
        type: 'divider',
        hideOnDesktop: true
      },
      {
        id: 'devices',
        title: 'Devices',
        icon: 'mdi-memory',
        to: { name: 'devices' }, //routeNames.DEVICES
        type: 'default'
      },
      {
        id: 'datasets',
        title: 'Datasets',
        icon: 'mdi-puzzle',
        to: { name: 'datasets' },
        type: 'default'
      },
      {
        id: 'media',
        title: 'Media',
        icon: 'mdi-image',
        to: { name: 'medias' },
        type: 'default'
      },
      {
        id: 'applications',
        title: 'Applications',
        icon: 'mdi-application-cog',
        to: { name: 'apps' },
        type: 'default'
      },
      {
        id: 'divider',
        type: 'divider'
      },
      {
        id: 'users',
        title: 'Users',
        icon: 'mdi-account',
        to: { name: 'users', params: { groupId: 'all' } },
        type: 'default'
      },
      {
        type: 'async',
        data: 'users',
        id: 'users groups',
        title: 'User groups',
        icon: 'mdi-account-supervisor'
      },
      {
        id: 'divider',
        type: 'divider'
      },
      {
        type: 'default',
        id: 'notifications',
        title: 'Notifications',
        icon: 'mdi-bell',
        to: { name: 'notifications' },
        ignore: true
      },
      {
        type: 'default',
        id: 'schedules',
        title: 'Schedules',
        to: { name: 'schedules' },
        icon: 'mdi-book-clock',
        ignore: true
      },
      {
        id: 'divider',
        type: 'divider'
      },
      {
        type: 'group',
        id: 'settings',
        title: 'Settings',
        icon: 'mdi-cog',
        children: [
          {
            type: 'default',
            id: 'schemas',
            title: 'Schemas',
            to: { name: 'schemas' },
            icon: ''
          },
          {
            type: 'default',
            id: 'datatypes',
            title: 'Data types',
            to: { name: 'datatypes' },
            icon: ''
          },
        ],
        disabled: false
      },
      {
        type: 'default',
        id: 'about',
        title: 'About',
        icon: 'mdi-information',
        component: 'about',
        ignore: true
      },
      {
        type: 'default',
        id: 'help',
        title: 'Help',
        icon: 'mdi-help-circle',
        external: true,
        ignore: true,
        link: window.__pixelConfig?.APP_DOC || DOC_URL
      }
    ]
  },
  mutations: {
    [SET_TOGGLE](state) {
      state.opened = !state.opened;
    }
  },
  actions: {
    toggle({ commit }) {
      commit(SET_TOGGLE);
    }
  }
});
